import { SimpleListing } from '@th/shared/src/types/SimpleListing';
import { Agent } from '@th/shared/src/types/Agent';
import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import PropertyInquiryForm from '../PropertyInquiryForm';
import SvgIcon from '../icons/SvgIcon';

type Props = {
  listing: SimpleListing;
  agent: Agent;
  isOpen: boolean;
  onClose: () => void;
};

// Credit: https://tailwindui.com/components/application-ui/overlays/slide-overs#component-3e8348c3c183bd14fceb018d4cca1942
// Modified to slide from bottom

export default function PropertyInquiryModal({
  listing,
  agent,
  isOpen,
  onClose,
}: Props) {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden ">
          <div className="absolute inset-0 overflow-hidden flex">
            {/*TODO: make this height match the content instead of h-3/4 - moving on for now */}
            <div className="pointer-events-none fixed inset-x-0 bottom-0 flex max-h-full h-3/4">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-y-full"
                enterTo="translate-y-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-y-0"
                leaveTo="translate-y-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen">
                  <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl ">
                    <div className="px-4 sm:px-6">
                      <div className="flex items-start justify-between">
                        <Dialog.Title className="text-lg font-medium text-gray-900">
                          Schedule Viewing
                        </Dialog.Title>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={() => onClose()}
                          >
                            <span className="sr-only">Close panel</span>
                            <SvgIcon
                              name={'HiX'}
                              className="h-6 w-6"
                              aria-hidden
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="relative mt-6 flex-1 px-4 sm:px-6">
                      <div className="absolute inset-0 px-4 sm:px-6">
                        <PropertyInquiryForm listing={listing} agent={agent} />
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
